import moment from 'moment';

export const getMinDate = () => moment().add(1, 'days').add(5, 'minutes').toDate();

export const getMaxDate = () => moment().add(31, 'days').toDate();
